<template>
  <div>
    <vue-loading
      :active="isLoading"
      :is-full-page="false"
      :height="24"
      :can-cancel="false"
      loader="spinner"
    />

    <div v-if="old" class="resultContainer">
      <b-container fluid class="mt-4">
        <b-row>
          <b-col class="">
            <div class="image-container">
              <img :src="getImageUrl()" alt="Old" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-4 mb-4">
            <b-card>
              <b-row>
                <b-col class="text-center">
                  <a
                    class="text-white btn btn-primary btn-link d-block"
                    :href="`https://portreti-spostovanja.sopotniki.org/${old}`"
                  >
                    <i class="fa fa-share"></i> Prenesi / deli sliko</a
                  >

                  <h5 class="mt-4">
                    <small class="text-muted" style="font-size: 16px"
                      >Nisi na svoji napravi?</small
                    ><br />Poskeniraj kodo
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-center mt-3 mb-3">
                  <qrcode-vue
                    :value="`https://portreti-spostovanja.sopotniki.org/${old}`"
                    :size="size"
                    level="H"
                    class="img-fluid"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center mt-0 mb-5">
            <b-button
              variant="secondary"
              block
              class="text-white"
              @click="$router.go(-1)"
            >
              <i class="fa fa-arrow-left"></i> Nazaj</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import VueLoading from "vue-loading-overlay";
import QrcodeVue from "qrcode.vue";

export default {
  name: "HomeView",
  components: {
    VueLoading,
    QrcodeVue,
  },
  data() {
    return {
      old: null,
      size: 300,
      isLoading: false,
    };
  },
  mounted() {
    this.old = this.$route.params.fileId;
  },
  methods: {
    getImageUrl() {
      return `https://api.pomagajmo.io/api/public/media/${btoa(
        encodeURI(
          "https://drive.google.com/thumbnail?authuser=0&sz=w1200&id=" +
            this.old
        )
      )}`;
    },
  },
};
</script>
